// extracted by mini-css-extract-plugin
export default {"spinner":"_3FiD","divider":"dnp3"};